import { useEffect, useLayoutEffect, useRef, useState } from "react";
import styles from "./NewAgentSearchPage.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import {
  calculateToDatePlus,
  currentDateSingle,
  getDateByMonth,
} from "../../../utils/utils";
import { SvgMan, SvgSearch } from "../../../utils/svgIcons";
import NewMultiSelectSearchHolidays from "../../NewSearchSateInput/NewMultiSelectSearchHolidays";
import DatePicker from "react-datepicker";
import { format, addDays } from "date-fns";
import PackagesStateInputNewUi from "../../PackagesStateInput/PackagesStateInputNewUi";
import GuestDetailsPopup from "../NewUiSearchForm/NewUiSearchFormHotels/GuestDetailsPopup";
import { toast } from "react-toastify";

function SingleHotelSearchForm({
  searchType,
  singleHotelPage,
  singleHotelData,
  handleRoomsChange,
}) {
  const [modifyPkg, setModiyPkg] = useState(false);
  const [mobileHead, setMobileHead] = useState(false);
  const toggleModify = () => {
    setModiyPkg(!modifyPkg);
  };
  const [dataFromChild, setDataFromChild] = useState("");
  const [destinationToggle, setdestinationToggle] = useState(false);
  const [selectedMultipleDestinations, setSelectedMultipleDestinations] =
    useState([]);

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);

    // Set width on mount
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const getDataFromChild = (data, resultArray) => {
    setDataFromChild(data);
    // setStateResultArray(resultArray)
    // console.log(resultArray);
  };
  // console.log(dataFromChild, "getDataFromChild");

  const [guestDetails, setIsguestDetails] = useState(false);
  const dropdownGuestDetails = () => {
    setIsguestDetails(!guestDetails);
  };

  const [selectedLocation, setSelectedLocation] = useState(null);
  const [data, setData] = useState({ fromCity: "", toCity: "" });

  const showErrorToast = (message) => {
    alert(message);
  };

  const [bookingData, setBookingData] = useState({});
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const checkinDay = queryParams.get("checkinDay") || "";
  const checkinMonth = queryParams.get("checkinMonth") || "";
  const checkinYear = queryParams.get("checkinYear") || "";
  const checkoutDay = queryParams.get("checkoutDay") || "";
  const checkoutMonth = queryParams.get("checkoutMonth") || "";
  const checkoutYear = queryParams.get("checkoutYear") || "";

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const childAges = [];
    let i = 1;

    while (params.has(`childAge[${i}]`)) {
      childAges.push(params.get(`childAge[${i}]`));
      i++;
    }

    const data = {
      hotelID: params.get("hotelID"),
      location: params.get("location"),
      room: params.get("room"),
      adult: params.get("adult"),
      children: params.get("children"),
      checkinDay: params.get("checkinDay"),
      checkinMonth: params.get("checkinMonth"),
      checkinYear: params.get("checkinYear"),
      checkoutDay: params.get("checkoutDay"),
      checkoutMonth: params.get("checkoutMonth"),
      checkoutYear: params.get("checkoutYear"),
      radio: params.get("radio"),
      childAge: childAges,
      multiple_destinations: params.get("selected_destinations"),
    };

    const checkInDate = `${data.checkinYear}-${String(
      data.checkinMonth
    ).padStart(2, "0")}-${String(data.checkinDay).padStart(2, "0")}`;
    const checkOutDate = `${data.checkoutYear}-${String(
      data.checkoutMonth
    ).padStart(2, "0")}-${String(data.checkoutDay).padStart(2, "0")}`;

    setData({
      fromCity: params.get("location"),
      // toCity: params.get("location"),
    });

    setAdults(data.adult ? data.adult : 2);
    setChildren(data.children ? data.children : 0);
    setRooms(data.room ? data.room : 1);
    setChildAge(childAges);
    setSelectedMultipleDestinations(
      data.multiple_destinations
        ?.split(",")
        ?.map((item) => item.trim())
        ?.filter((item) => item !== "")
    );

    if (!data.checkinDay) {
      setStartDate(currentDateSingle);
      setEndDate(calculateToDatePlus(currentDateSingle, 1));
    } else {
      setStartDate(checkInDate);
      setEndDate(checkOutDate);
    }

    setBookingData(data);
    // postBookingData(data);
  }, [location.search]);

  // popup details
  const [storeRoomsData, setStoreRoomsData] = useState([
    { id: 1, adult: 2, children: [] },
  ]);
  const [adult, setAdults] = useState(2);
  const [children, setChildren] = useState(0);
  const [childAge, setChildAge] = useState([]);
  const [rooms, setRooms] = useState(1);

  // console.log(storeRoomsData, "storeRoomsData"); 

  useEffect(() => {
    const restoredData = location.state?.storeRoomsData;

    if (restoredData) {
      setStoreRoomsData(restoredData);
      setRooms(restoredData.length);
      updateTotalAdults(restoredData);

      const allChildren = restoredData.flatMap((room) => room.children);
      setChildren(allChildren.length);
      setChildAge(allChildren);
    }
  }, [location.state]);

  const addRoom = () => {
    setStoreRoomsData((prevRooms) => {
      if (prevRooms.length >= 6) return prevRooms;

      const newRoomId =
        prevRooms.length > 0 ? prevRooms[prevRooms.length - 1].id + 1 : 1;
      const newRooms = [
        ...prevRooms,
        { id: newRoomId, adult: 1, children: [] },
      ];

      setRooms(newRooms.length);
      updateTotalAdults(newRooms);

      return newRooms;
    });
  };

  const removeRoom = (roomId) => {
    const newRooms = storeRoomsData.filter((room) => room.id !== roomId);
    setStoreRoomsData(newRooms);
    setRooms(newRooms.length); // Update the room count
    updateTotalAdults(newRooms);

    const childrens = newRooms?.flatMap((child) => child?.children);

    setChildren(childrens?.length);
  };

  const updateTotalAdults = (updatedRooms) => {
    const totalAdults = updatedRooms.reduce((sum, room) => sum + room.adult, 0);
    setAdults(totalAdults);
  };

  const onAdultIncrease = (roomId) => {
    const updatedRooms = storeRoomsData.map((room) =>
      room.id === roomId
        ? { ...room, adult: Math.min(room.adult + 1, 4) }
        : room
    );
    setStoreRoomsData(updatedRooms);
    updateTotalAdults(updatedRooms);
  };

  const onAdultDecrease = (roomId) => {
    const updatedRooms = storeRoomsData.map((room) =>
      room.id === roomId
        ? { ...room, adult: Math.max(room.adult - 1, 1) }
        : room
    );
    setStoreRoomsData(updatedRooms);
    updateTotalAdults(updatedRooms);
  };

  const addChildAge = (roomId, age) => {
    const room = storeRoomsData.find((room) => room.id === roomId);
    if (room && room.children.length >= 3) {
      toast.error("You can add a maximum of 3 children in one room.");
      return;
    }

    setStoreRoomsData((prevRooms) =>
      prevRooms.map((room) =>
        room.id === roomId
          ? room.children.length < 3
            ? {
                ...room,
                children: [...room.children, age],
                showGuestDetailsPopup: !room.showGuestDetailsPopup,
              }
            : room
          : room
      )
    );

    // if (childAge.length < 3) {
    setChildren(Number(children) + 1);
    setChildAge([...childAge, age]);
    // }
  };

  const removeChild = (roomId, indexToRemove) => {
    let removedAge;
    setStoreRoomsData((prevRooms) =>
      prevRooms.map((room) => {
        if (room.id === roomId) {
          removedAge = room.children[indexToRemove];
          return {
            ...room,
            children: room.children.filter(
              (_, index) => index !== indexToRemove
            ),
          };
        }
        return room;
      })
    );
    setChildren(children - 1);
    setChildAge(
      childAge.filter((_, index) => index !== childAge.indexOf(removedAge))
    );
  };

  const toggleGuestDetailsPopup = (roomId) => {
    setStoreRoomsData((prevRooms) =>
      prevRooms.map((room) =>
        room.id === roomId
          ? { ...room, showGuestDetailsPopup: !room.showGuestDetailsPopup }
          : room
      )
    );
  };
  // end popup details
  const [checkin, setCheckin] = useState({
    day: checkinDay,
    month: checkinMonth,
    year: checkinYear,
  });

  const [checkout, setCheckout] = useState({
    day: checkoutDay,
    month: checkoutMonth,
    year: checkoutYear,
  });
  const navigate = useNavigate();
  // popup details

  // STATES
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(calculateToDatePlus(new Date(), 1));
  const [date, setDate] = useState(new Date());
  const [hotelData, setHotelData] = useState([]);

  const [selectedRadio, setSelectedRadio] = useState("");

  //
  // const [adult, setAdults] = useState([]);
  // const [children, setChildren] = useState(0);
  // const [rooms, setRooms] = useState(1);
  // const [childAge, setChildAge] = useState([]);

  // Date alterations
  const [loader, setLoader] = useState(false);

  const dropdownRef = useRef(null);
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      // Click is outside the dropdown, so close it
      // setIsguestDetails(false);
    }
  };
  const popupsRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (popupsRef.current && !popupsRef.current.contains(event.target)) {
        setIsguestDetails(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  // functions for increase decrease
  const onChildDecrease = (e) => {
    e.preventDefault();
    const updatedChildren = Number(children) - 1;
    setChildren(updatedChildren);
    const updatedAges = childAge.slice(0, childAge.length - 1);
    setChildAge(updatedAges);
  };

  const onChildIncrease = (e) => {
    e.preventDefault();
    const updatedChildren = Number(children) + 1;
    setChildren(updatedChildren);
    setChildAge([...childAge, ""]);
  };

  // const onAdultIncrease = () => {
  //   const newAdult = Number(adult) + 1;
  //   setAdults(newAdult);
  //   if (newAdult > 1 && newAdult % 2 === 0 && rooms < newAdult / 2) {
  //     setRooms(Number(rooms) + 1);
  //   }
  // };

  // const onAdultDecrease = () => {
  //   if (adult > 1) {
  //     const newAdult = Number(adult) - 1;
  //     setAdults(newAdult);
  //     if (newAdult % 2 !== 0 && rooms > 1) {
  //       setRooms(Number(rooms) - 1);
  //     }
  //   }
  // };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
  };

  const handleChildrenAgeChange = (index, event) => {
    const updatedAges = [...childAge];
    const ageValue = event.target.value.replace(/[^0-9]/g, "");

    if (ageValue > 12) {
      showErrorToast("Age should be less than or equal to 12");
      return;
    }

    updatedAges[index] = ageValue !== "" ? parseInt(ageValue, 10) : "";
    setChildAge(updatedAges);
  };

  const handleSubmitButtonClickHandlerListingHotels = async (e) => {
    if (e) {
      e.preventDefault();
    }
    let hasChildAgeError = false;

    const sanitizedChildAges = childAge
      .map((age) => (age !== "" ? age : null))
      .filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      .map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=${age}`;
      })
      .join("");

    if (hasChildAgeError) {
      alert("Child age must be between 0 and 12");
      return;
    }
    setLoader(true);
    setModiyPkg(false);

    try {
      await navigate(
        `/listing-hotels?location=${dataFromChild}&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&checkinDay=${new Date(
          startDate
        ).getDate()}&checkinMonth=${
          new Date(startDate).getMonth() + 1
        }&checkinYear=${new Date(
          startDate
        ).getFullYear()}&checkoutDay=${new Date(
          endDate
        ).getDate()}&checkoutMonth=${
          new Date(endDate).getMonth() + 1
        }&checkoutYear=${new Date(
          endDate
        ).getFullYear()}&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&radio=${
          bookingData.radio
        }&selected_destinations=${selectedMultipleDestinations}`,
        // `/searchresults?hotelID=&location=${property_city}&checkinDay=${checkin.day}&checkinMonth=${checkin.month}&checkinYear=${checkin.year}&checkoutDay=${checkout.day}&checkoutMonth=${checkout.month}&checkoutYear=${checkout.year}&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&checkIn=${formated_start_date}&checkOut=${formated_end_date}&noOfNights=${noOfNights}#hotels`,
        undefined,
        { shallow: false }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
      setModiyPkg(false);
    } finally {
      setLoader(false);
    }
  };
  const handleSubmitButtonSingleHotel = async (e) => {
    if (e) e.preventDefault();

    if (childAge.some((age) => age === "")) {
      showErrorToast("Please enter age for all children");
      return;
    }

    let hasChildAgeError = false;

    const sanitizedChildAges = childAge
      .map((age) => (age !== "" ? age : null))
      .filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      .map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=${age}`;
      })
      .join("");

    if (hasChildAgeError) {
      alert("Child age must be between 0 and 12");
      return;
    }

    setLoader(true);
    setModiyPkg(false);

    try {
      // ✅ Save to localStorage before navigating
      localStorage.setItem("storeRoomsData", JSON.stringify(storeRoomsData));

      await navigate(
        `/single-hotel-search/${singleHotelData?.slug}/${
          singleHotelData?.hotelId
        }?location=${dataFromChild}&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&checkinDay=${new Date(
          startDate
        ).getDate()}&checkinMonth=${
          new Date(startDate).getMonth() + 1
        }&checkinYear=${new Date(
          startDate
        ).getFullYear()}&checkoutDay=${new Date(
          endDate
        ).getDate()}&checkoutMonth=${
          new Date(endDate).getMonth() + 1
        }&checkoutYear=${new Date(endDate).getFullYear()}&radio=${
          bookingData.radio
        }&selected_destinations=${selectedMultipleDestinations}&hotel_name=Golden%20Fern%20Resort%20Shimla&hotel_address=Kachi%20Ghatti,%20Shimla,%20Himachal%20Pradesh%20171010`,
        {
          state: { storeRoomsData },
        }
      );
    } catch (error) {
      console.error("Error navigating:", error);
      setLoader(false);
      setModiyPkg(false);
    } finally {
      setLoader(false);
    }
  };

  const handleSubmitButtonClickHandler = async (e) => {
    if (e) {
      e.preventDefault();
    }
    let hasChildAgeError = false;

    const sanitizedChildAges = childAge
      .map((age) => (age !== "" ? age : null))
      .filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      .map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=${age}`;
      })
      .join("");

    if (hasChildAgeError) {
      return;
    }

    setLoader(true);
    setModiyPkg(false);

    try {
      await navigate(
        `/listing-hotels?hotelID=1&location=${dataFromChild}&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&checkinDay=${new Date(
          startDate
        ).getDate()}&checkinMonth=${
          new Date(startDate).getMonth() + 1
        }&checkinYear=${new Date(
          startDate
        ).getFullYear()}&checkoutDay=${new Date(
          endDate
        ).getDate()}&checkoutMonth=${
          new Date(endDate).getMonth() + 1
        }&checkoutMonth=${new Date(
          endDate
        ).getFullYear()}&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&radio=${selectedRadio}&selected_destinations=${selectedMultipleDestinations}`,
        // `/searchresults?hotelID=&location=${property_city}&checkinDay=${checkin.day}&checkinMonth=${checkin.month}&checkinYear=${checkin.year}&checkoutDay=${checkout.day}&checkoutMonth=${checkout.month}&checkoutYear=${checkout.year}&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&checkIn=${formated_start_date}&checkOut=${formated_end_date}&noOfNights=${noOfNights}#hotels`,
        undefined,
        { shallow: false }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
      setModiyPkg(false);
    } finally {
      setLoader(false);
    }
  };

  const handleSubmitButtonClickHandlerAllHotels = async (e) => {
    if (e) {
      e.preventDefault();
    }
    let hasChildAgeError = false;

    const sanitizedChildAges = childAge
      .map((age) => (age !== "" ? age : null))
      .filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      .map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=${age}`;
      })
      .join("");

    if (hasChildAgeError) {
      alert("Child age must be between 0 and 12");
      return;
    }
    setLoader(false);
    setModiyPkg(false);

    try {
      await navigate(
        `/all-hotels?location=${dataFromChild}&selected_destinations=${selectedMultipleDestinations}`,
        // `/searchresults?hotelID=&location=${property_city}&checkinDay=${checkin.day}&checkinMonth=${checkin.month}&checkinYear=${checkin.year}&checkoutDay=${checkout.day}&checkoutMonth=${checkout.month}&checkoutYear=${checkout.year}&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&checkIn=${formated_start_date}&checkOut=${formated_end_date}&noOfNights=${noOfNights}#hotels`,
        undefined,
        { shallow: false }
      );
      setModiyPkg(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
      setModiyPkg(false);
    } finally {
      setLoader(false);
    }
  };

  const handleDateChange = ([start, end]) => {
    // setDateRange([start, end]);
    setStartDate(start);
    setEndDate(end);
  };

  const capitalizeFirstLetter = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  console.log("width", width);

  const [height, setHeight] = useState(window.innerHeight);

  // useEffect(() => {
  //   if (window.innerWidth <= 640) {
  //     setMobileHead(true);

  //   } else {
  //     setMobileHead(false);
  //   }

  // }, [width]);
  // console.log("mobileHead", mobileHead);

  //   useEffect(() => {
  //     if (window.innerWidth <= 640) {
  //         setMobileHead(true);
  //     } else {
  //         setMobileHead(false);
  //     }
  // }, []);

  const updateDimensions = () => {
    // console.log("window.innerWidth", window.innerWidth);

    if (width > 640) {
      setMobileHead(false);
    } else {
      setMobileHead(true);
    }
  };

  useEffect(() => {
    // Call the function on initial render
    // updateDimensions();

    // Add event listener for window resize
    window.addEventListener("resize", updateDimensions);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener("resize", updateDimensions);
  }, [width]);
  // console.log(endDate, 'endDate');
  const [showGuestDetailsPopup, setShowGuestDetailsPopup] = useState(false);
  const availableAges = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

  // Function to add a child's age
  const handleAddChildAge = (age) => {
    setChildAge((prevAges) => {
      const newAges = [...prevAges, age];
      setChildren(newAges.length);
      return newAges;
    });
    setShowGuestDetailsPopup(false);
  };

  // Function to remove a child's age
  const handleRemoveChild = (indexToRemove) => {
    setChildAge((prevAges) => {
      const newAges = prevAges.filter((_, index) => index !== indexToRemove);
      setChildren(newAges.length);
      return newAges;
    });
  };

  const handleMultiDestinationsChange = (selected) => {
    setSelectedMultipleDestinations(selected);
  };

  return (
    <section
      className={styles.EditSearchParentWrapper}
      id="HotelEditSearchForm"
    >
      <div className={styles.singleSearch} id="singleSearch">
        {/* {singleHotelPage ? ( */}
        {searchType === "hotel_listing" && (
          <form
            action=""
            className={styles.EditSearchFormWrapper}
            id="main-form"
            onSubmit={
              searchType === "hotel_listing"
                ? handleSubmitButtonClickHandlerListingHotels
                : handleSubmitButtonClickHandler
            }
          >
            {/* {width} */}
            {width <= 640 ? (
              <>
                {/* <div className={styles.EditSearchParentWrapperMobile}>
                  <div className="flex_align_center">
                    <span onClick={() => window.history.back()}>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.292893 7.29289C-0.0976311 7.68342 -0.0976311 8.31658 0.292893 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292893 7.29289ZM1 9H16V7H1V9Z"
                          fill="#333333"
                        />
                      </svg>
                    </span>
                    <div className="SingleSearch-resp_content">
                      <h4 style={{ fontSize: "16px", lineHeight: "20px" }}>
                        {data?.fromCity ? (
                          capitalizeFirstLetter(data.fromCity)
                        ) : (
                          <p>Enter a destination</p>
                        )}
                      </h4>
                      <div style={{ fontSize: "14px", lineHeight: "20px" }}>
                        <span>{endDate}</span>
                        <span> | </span>
                        <span>
                          {adult} adult, {children} Child
                        </span>
                      </div>
                    </div>
                  </div>
                  <div onClick={toggleModify}>
                    {modifyPkg ? (
                      <span style={{ marginRight: "10px" }}>X</span>
                    ) : (
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_2797_7470"
                          style={{ maskType: "alpha" }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="20"
                          height="20"
                        >
                          <rect width="20" height="20" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_2797_7470)">
                          <path
                            d="M4.16667 15.8333H5.35417L13.5 7.6875L12.3125 6.5L4.16667 14.6458V15.8333ZM2.5 17.5V13.9583L13.5 2.97917C13.6667 2.82639 13.8507 2.70833 14.0521 2.625C14.2535 2.54167 14.4653 2.5 14.6875 2.5C14.9097 2.5 15.125 2.54167 15.3333 2.625C15.5417 2.70833 15.7222 2.83333 15.875 3L17.0208 4.16667C17.1875 4.31944 17.309 4.5 17.3854 4.70833C17.4618 4.91667 17.5 5.125 17.5 5.33333C17.5 5.55556 17.4618 5.76736 17.3854 5.96875C17.309 6.17014 17.1875 6.35417 17.0208 6.52083L6.04167 17.5H2.5ZM12.8958 7.10417L12.3125 6.5L13.5 7.6875L12.8958 7.10417Z"
                            fill="#333333"
                          />
                        </g>
                      </svg>
                    )}
                  </div>
                </div> */}

                <div className={styles.mobile_new_wrapper_container}>
                  <div
                    onClick={toggleModify}
                    className={styles.mobile_new_wrapper}
                  >
                    <div className={styles.mobile_new_left_div}>
                      <div>
                        {" "}
                        <SvgSearch />
                      </div>
                      <div className={styles.mobile_new_left_div_location}>
                        {data.fromCity &&
                          data.fromCity !== "" &&
                          data.fromCity != null &&
                          data.fromCity != "null" &&
                          capitalizeFirstLetter(data.fromCity) + ", "}
                        <br />
                        <span>
                          {getDateByMonth(startDate) +
                            " - " +
                            getDateByMonth(endDate) +
                            ""}
                        </span>
                      </div>
                    </div>

                    <div className={styles.mobile_new_right_div}>
                      <div className={styles.mobile_new_right_div_svg}>
                        <SvgMan />
                      </div>
                      <div className={styles.mobile_new_right_div_guest}>
                        {adult}
                      </div>
                    </div>
                  </div>

                  {modifyPkg && (
                    <div className={styles.lower_form}>
                      <div>
                        {/* <label htmlFor="">City/Destination</label> */}
                        {/* <GooglePlaceApi
                        setSelectedLocation={setSelectedLocation}
                        data={data}
                        defaultValue={data?.fromCity && data.fromCity}
                        setData={setData}
                        showErrorToast={showErrorToast}
                        position={"SingleSearchForm"}
                      /> */}
                        <label htmlFor="">City/Destination</label>
                        {/* <PackagesStateInputNewUi
                          onDataChange={getDataFromChild}
                          width={width}
                          // disableSearchInput={true}
                        /> */}
                        <NewMultiSelectSearchHolidays
                          onClick={() => setdestinationToggle(true)}
                          onMultiSelectionChange={handleMultiDestinationsChange}
                          // selectedMultipleDestinations={selectedMultipleDestinations}
                          defaultSelected={selectedMultipleDestinations}
                          className={"search_form_input"}
                        />
                      </div>
                      <div className="new_date_picker_react_js_custom_styling">
                        <label>Check In - Check Out</label>
                        <DatePicker
                          selected={startDate}
                          onChange={(dates) => {
                            const [start, end] = dates;
                            setStartDate(start);
                            setEndDate(end);
                          }}
                          startDate={startDate}
                          endDate={endDate}
                          selectsRange
                          portalId="root-portal NewUIReactDatePicker"
                          popperPlacement="bottom-start"
                          minDate={new Date()} // Prevent past dates selection
                          dateFormat="dd MMM, yyyy"
                          placeholderText={`${format(
                            startDate,
                            "dd MMM, yyyy"
                          )} - ${format(endDate, "dd MMM, yyyy")}`}
                        />
                        {/* <label>Check In</label>
                        <input
                          className="testform_input"
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                          type="date"
                          required
                        />
                      </div>
                      <div className="">
                        <label>Check Out</label>
                        <input
                          className="testform_input"
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                          type="date"
                          required
                        /> */}
                      </div>
                      <div className="search_form_div p_0 icon_button_only">
                        <label
                          onClick={dropdownGuestDetails}
                          className="search_label"
                        >
                          Room & Guests{" "}
                          <svg
                            width="9"
                            height="5"
                            viewBox="0 0 9 5"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.25 0.75L4.75 4.25L1.25 0.75"
                              stroke="#BB735D"
                            />
                          </svg>
                        </label>
                        <p
                          style={{ position: "relative" }}
                          className="SingleSearch-Guests dropdown-toggle search_form_input testform_input"
                        >
                          <div onClick={dropdownGuestDetails} ref={dropdownRef}>
                            <div className="optionCounter"></div>
                            <span id="adults_count">{adult}</span>
                            <span> Adults,</span>{" "}
                            <span id="room_count">{rooms}</span>
                            <span> Rooms, </span>{" "}
                            <span id="child_count">{children}</span>
                            <span> Children</span>
                          </div>
                          {guestDetails && (
                            <div ref={dropdownRef} className="popup-container">
                              <GuestDetailsPopup
                                guestDetails={guestDetails}
                                setIsguestDetails={setIsguestDetails}
                                adult={adult}
                                setAdults={setAdults}
                                children={children}
                                setChildren={setChildren}
                                rooms={storeRoomsData}
                                setRooms={setStoreRoomsData}
                                onRoomsChange={setStoreRoomsData}
                                handleRoomsUpdate={setStoreRoomsData}
                                setChildAge={setChildAge}
                                onAdultChange={setAdults}
                                childAge={childAge}
                                removeRoom={removeRoom}
                                onAdultIncrease={onAdultIncrease}
                                onAdultDecrease={onAdultDecrease}
                                toggleGuestDetailsPopup={
                                  toggleGuestDetailsPopup
                                }
                                addRoom={addRoom}
                                addChildAge={addChildAge}
                                removeChild={removeChild}
                                availableAges={[2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}
                              />
                            </div>
                          )}
                        </p>
                      </div>
                      <button
                        style={{ marginBottom: "10px" }}
                        type="submit"
                        className={styles.submitButton}
                      >
                        Modify
                      </button>
                    </div>
                  )}
                </div>
              </>
            ) : (
              <div className={styles.EditSearchFormParent}>
                <div className={styles.EditSearchFormChild}>
                  <div className={styles.EditSearchFormChildFirstDiv}>
                    <NewMultiSelectSearchHolidays
                      onClick={() => setdestinationToggle(true)}
                      onMultiSelectionChange={handleMultiDestinationsChange}
                      // selectedMultipleDestinations={selectedMultipleDestinations}
                      defaultSelected={selectedMultipleDestinations}
                      className={"search_form_input"}
                    />
                  </div>
                  <div
                    className={`${styles.EditSearchFormChildSecondDiv} new_date_picker_react_js_custom_styling`}
                  >
                    {/* <Flatpickr
                      style={{ fontWeight: "lighter" }}
                      className="testform_input"
                      value={[startDate, endDate]}
                      onChange={([date1, date2]) => {
                        setStartDate(date1 || null);
                        setEndDate(date2 || null);
                      }}
                      options={{
                        mode: "range",
                        minDate: "today", // Prevent selection of past dates
                      }}
                      required
                    /> */}

                    <DatePicker
                      selected={startDate}
                      onChange={(dates) => {
                        const [start, end] = dates;
                        setStartDate(start);
                        setEndDate(end);
                      }}
                      startDate={startDate}
                      endDate={endDate}
                      selectsRange
                      portalId="root-portal NewUIReactDatePicker"
                      popperPlacement="bottom-start"
                      minDate={new Date()} // Prevent past dates selection
                      dateFormat="dd MMM, yyyy"
                      placeholderText={`${format(
                        startDate,
                        "dd MMM, yyyy"
                      )} - ${format(endDate, "dd MMM, yyyy")}`}
                    />
                  </div>
                  <div className={styles.EditSearchFormChildThirdDiv}>
                    <p
                      style={{ position: "relative" }}
                      className="SingleSearch-Guests dropdown-toggle search_form_input testform_input"
                    >
                      <div onClick={dropdownGuestDetails} ref={dropdownRef}>
                        <div className="optionCounter"></div>
                        <span id="adults_count">{adult}</span>
                        <span> Adults,</span>{" "}
                        <span id="room_count">{rooms}</span>
                        <span> Rooms, </span>{" "}
                        <span id="child_count">{children}</span>
                        <span> Children</span>
                      </div>
                      {guestDetails && (
                        <div ref={dropdownRef} className="popup-container">
                          <GuestDetailsPopup
                            guestDetails={guestDetails}
                            setIsguestDetails={setIsguestDetails}
                            adult={adult}
                            setAdults={setAdults}
                            children={children}
                            setChildren={setChildren}
                            rooms={storeRoomsData}
                            setRooms={setStoreRoomsData}
                            onRoomsChange={setStoreRoomsData}
                            handleRoomsUpdate={setStoreRoomsData}
                            setChildAge={setChildAge}
                            onAdultChange={setAdults}
                            childAge={childAge}
                            removeRoom={removeRoom}
                            onAdultIncrease={onAdultIncrease}
                            onAdultDecrease={onAdultDecrease}
                            toggleGuestDetailsPopup={toggleGuestDetailsPopup}
                            addRoom={addRoom}
                            addChildAge={addChildAge}
                            removeChild={removeChild}
                            availableAges={[2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}
                          />
                        </div>
                      )}
                    </p>
                  </div>
                </div>
                <button type="submit" className={styles.submitButton}>
                  Modify
                </button>
              </div>
            )}
          </form>
        )}
        {searchType === "all_hotels" && (
          <form
            action=""
            className={styles.EditSearchFormWrapper}
            id="main-form"
            // onSubmit={
            //   searchType === "hotel_listing"
            //     ? handleSubmitButtonClickHandlerListingHotels
            //     : handleSubmitButtonClickHandler
            // }
            onSubmit={handleSubmitButtonClickHandlerListingHotels}
          >
            {/* {width} */}
            {width <= 640 ? (
              <>
                {/* <div className={styles.EditSearchParentWrapperMobile}>
                <div className="flex_align_center">
                  <span onClick={() => window.history.back()}>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.292893 7.29289C-0.0976311 7.68342 -0.0976311 8.31658 0.292893 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292893 7.29289ZM1 9H16V7H1V9Z"
                        fill="#333333"
                      />
                    </svg>
                  </span>
                  <div className="SingleSearch-resp_content">
                    <h4 style={{ fontSize: "16px", lineHeight: "20px" }}>
                      {data?.fromCity ? (
                        capitalizeFirstLetter(data.fromCity)
                      ) : (
                        <p>Enter a destination</p>
                      )}
                    </h4>
                    <div style={{ fontSize: "14px", lineHeight: "20px" }}>
                      <span>{endDate}</span>
                      <span> | </span>
                      <span>
                        {adult} adult, {children} Child
                      </span>
                    </div>
                  </div>
                </div>
                <div onClick={toggleModify}>
                  {modifyPkg ? (
                    <span style={{ marginRight: "10px" }}>X</span>
                  ) : (
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_2797_7470"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="20"
                        height="20"
                      >
                        <rect width="20" height="20" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_2797_7470)">
                        <path
                          d="M4.16667 15.8333H5.35417L13.5 7.6875L12.3125 6.5L4.16667 14.6458V15.8333ZM2.5 17.5V13.9583L13.5 2.97917C13.6667 2.82639 13.8507 2.70833 14.0521 2.625C14.2535 2.54167 14.4653 2.5 14.6875 2.5C14.9097 2.5 15.125 2.54167 15.3333 2.625C15.5417 2.70833 15.7222 2.83333 15.875 3L17.0208 4.16667C17.1875 4.31944 17.309 4.5 17.3854 4.70833C17.4618 4.91667 17.5 5.125 17.5 5.33333C17.5 5.55556 17.4618 5.76736 17.3854 5.96875C17.309 6.17014 17.1875 6.35417 17.0208 6.52083L6.04167 17.5H2.5ZM12.8958 7.10417L12.3125 6.5L13.5 7.6875L12.8958 7.10417Z"
                          fill="#333333"
                        />
                      </g>
                    </svg>
                  )}
                </div>
              </div> */}

                <div className={styles.mobile_new_wrapper_container}>
                  <div
                    onClick={toggleModify}
                    className={styles.mobile_new_wrapper}
                  >
                    <div className={styles.mobile_new_left_div}>
                      <div>
                        {" "}
                        <SvgSearch />
                      </div>
                      <div className={styles.mobile_new_left_div_location}>
                        {data.fromCity &&
                          data.fromCity !== "" &&
                          data.fromCity != null &&
                          data.fromCity != "null" &&
                          capitalizeFirstLetter(data.fromCity) + ", "}
                        <br />
                        <span>
                          {getDateByMonth(startDate) +
                            " - " +
                            getDateByMonth(endDate) +
                            ""}
                        </span>
                      </div>
                    </div>

                    <div className={styles.mobile_new_right_div}>
                      <div className={styles.mobile_new_right_div_svg}>
                        <SvgMan />
                      </div>
                      <div className={styles.mobile_new_right_div_guest}>
                        {adult}
                      </div>
                    </div>
                  </div>

                  {modifyPkg && (
                    <div className={styles.lower_form}>
                      <div>
                        {/* <label htmlFor="">City/Destination</label> */}
                        {/* <GooglePlaceApi
                      setSelectedLocation={setSelectedLocation}
                      data={data}
                      defaultValue={data?.fromCity && data.fromCity}
                      setData={setData}
                      showErrorToast={showErrorToast}
                      position={"SingleSearchForm"}
                    /> */}
                        <label htmlFor="">City/Destination</label>
                        {/* <PackagesStateInputNewUi
                          onDataChange={getDataFromChild}
                          width={width}
                          // disableSearchInput={true}
                          
                        /> */}
                        <NewMultiSelectSearchHolidays
                          onClick={() => setdestinationToggle(true)}
                          onMultiSelectionChange={handleMultiDestinationsChange}
                          // selectedMultipleDestinations={selectedMultipleDestinations}
                          defaultSelected={selectedMultipleDestinations}
                          className={"search_form_input"}
                        />
                      </div>
                      <div className="new_date_picker_react_js_custom_styling">
                        <label>Check In - Check Out</label>
                        <DatePicker
                          selected={startDate}
                          onChange={(dates) => {
                            const [start, end] = dates;
                            setStartDate(start);
                            setEndDate(end);
                          }}
                          startDate={startDate}
                          endDate={endDate}
                          selectsRange
                          portalId="root-portal NewUIReactDatePicker"
                          popperPlacement="bottom-start"
                          minDate={new Date()} // Prevent past dates selection
                          dateFormat="dd MMM, yyyy"
                          placeholderText={`${format(
                            startDate,
                            "dd MMM, yyyy"
                          )} - ${format(endDate, "dd MMM, yyyy")}`}
                        />
                        {/* <input
                          className="testform_input"
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                          type="date"
                          required
                        />
                      </div>
                      <div className="">
                        <label>Check Out</label>
                        <input
                          className="testform_input"
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                          type="date"
                          required
                        /> */}
                      </div>
                      <div className="search_form_div p_0 icon_button_only">
                        <label
                          onClick={dropdownGuestDetails}
                          className="search_label"
                        >
                          Room & Guests{" "}
                          <svg
                            width="9"
                            height="5"
                            viewBox="0 0 9 5"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.25 0.75L4.75 4.25L1.25 0.75"
                              stroke="#BB735D"
                            />
                          </svg>
                        </label>
                        <p
                          style={{ position: "relative" }}
                          className="SingleSearch-Guests dropdown-toggle search_form_input testform_input"
                        >
                          <div onClick={dropdownGuestDetails} ref={dropdownRef}>
                            <div className="optionCounter"></div>
                            <span id="adults_count">{adult}</span>
                            <span> Adults,</span>{" "}
                            <span id="room_count">{rooms}</span>
                            <span> Rooms, </span>{" "}
                            <span id="child_count">{children}</span>
                            <span> Children</span>
                          </div>
                          {guestDetails && (
                            <div ref={dropdownRef} className="popup-container">
                              <GuestDetailsPopup
                                guestDetails={guestDetails}
                                setIsguestDetails={setIsguestDetails}
                                adult={adult}
                                setAdults={setAdults}
                                children={children}
                                setChildren={setChildren}
                                rooms={storeRoomsData}
                                setRooms={setStoreRoomsData}
                                onRoomsChange={setStoreRoomsData}
                                handleRoomsUpdate={setStoreRoomsData}
                                setChildAge={setChildAge}
                                onAdultChange={setAdults}
                                childAge={childAge}
                                removeRoom={removeRoom}
                                onAdultIncrease={onAdultIncrease}
                                onAdultDecrease={onAdultDecrease}
                                toggleGuestDetailsPopup={
                                  toggleGuestDetailsPopup
                                }
                                addRoom={addRoom}
                                addChildAge={addChildAge}
                                removeChild={removeChild}
                                availableAges={[2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}
                              />
                            </div>
                          )}
                        </p>
                      </div>
                      <button
                        style={{ marginBottom: "10px" }}
                        type="submit"
                        className={styles.submitButton}
                      >
                        Modify
                      </button>
                    </div>
                  )}
                </div>
              </>
            ) : (
              <div className={styles.EditSearchFormParent}>
                <div className={styles.EditSearchFormChild}>
                  <div className={styles.EditSearchFormChildFirstDiv}>
                    <PackagesStateInputNewUi
                      onDataChange={getDataFromChild}
                      width={width}
                      // disableSearchInput={true}
                    />
                  </div>
                  <div
                    className={`${styles.EditSearchFormChildSecondDiv} new_date_picker_react_js_custom_styling`}
                  >
                    {/* <Flatpickr
                      style={{ fontWeight: "lighter" }}
                      className="testform_input"
                      value={[startDate, endDate]}
                      onChange={([date1, date2]) => {
                        setStartDate(date1 || null);
                        setEndDate(date2 || null);
                      }}
                      options={{
                        mode: "range",
                        minDate: "today", // Prevent selection of past dates
                      }}
                      required
                    /> */}

                    <DatePicker
                      selected={startDate}
                      onChange={(dates) => {
                        const [start, end] = dates;
                        setStartDate(start);
                        setEndDate(end);
                      }}
                      startDate={startDate}
                      endDate={endDate}
                      selectsRange
                      portalId="root-portal NewUIReactDatePicker"
                      popperPlacement="bottom-start"
                      minDate={new Date()} // Prevent past dates selection
                      dateFormat="dd MMM, yyyy"
                      placeholderText={`${format(
                        startDate,
                        "dd MMM, yyyy"
                      )} - ${format(endDate, "dd MMM, yyyy")}`}
                    />
                  </div>
                  <div className={styles.EditSearchFormChildThirdDiv}>
                    <p
                      style={{ position: "relative" }}
                      className="SingleSearch-Guests dropdown-toggle search_form_input testform_input"
                    >
                      <div onClick={dropdownGuestDetails} ref={dropdownRef}>
                        <div className="optionCounter"></div>
                        <span id="adults_count">{adult}</span>
                        <span> Adults,</span>{" "}
                        <span id="room_count">{rooms}</span>
                        <span> Rooms, </span>{" "}
                        <span id="child_count">{children}</span>
                        <span> Children</span>
                      </div>
                      {guestDetails && (
                        <div ref={dropdownRef} className="popup-container">
                          <GuestDetailsPopup
                            guestDetails={guestDetails}
                            setIsguestDetails={setIsguestDetails}
                            adult={adult}
                            setAdults={setAdults}
                            children={children}
                            setChildren={setChildren}
                            rooms={storeRoomsData}
                            setRooms={setStoreRoomsData}
                            onRoomsChange={setStoreRoomsData}
                            handleRoomsUpdate={setStoreRoomsData}
                            setChildAge={setChildAge}
                            onAdultChange={setAdults}
                            childAge={childAge}
                            removeRoom={removeRoom}
                            onAdultIncrease={onAdultIncrease}
                            onAdultDecrease={onAdultDecrease}
                            toggleGuestDetailsPopup={toggleGuestDetailsPopup}
                            addRoom={addRoom}
                            addChildAge={addChildAge}
                            removeChild={removeChild}
                            availableAges={[2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}
                          />
                        </div>
                      )}
                    </p>
                  </div>
                </div>
                <button type="submit" className={styles.submitButton}>
                  Modify
                </button>
              </div>
            )}
          </form>
        )}
        {searchType === "single_hotel" && (
          <form
            action=""
            className={styles.EditSearchFormWrapper}
            id="main-form"
            onSubmit={handleSubmitButtonSingleHotel}
          >
            {/* {width} */}
            {width <= 640 ? (
              <div className={styles.mobile_new_wrapper_container}>
                <div
                  onClick={toggleModify}
                  className={styles.mobile_new_wrapper}
                >
                  <div className={styles.mobile_new_left_div}>
                    <div>
                      {" "}
                      <SvgSearch />
                    </div>
                    <div className={styles.mobile_new_left_div_location}>
                      {data.fromCity &&
                        data.fromCity !== "" &&
                        data.fromCity != null &&
                        data.fromCity != "null" &&
                        capitalizeFirstLetter(data.fromCity) + ", "}{" "}
                      <br />
                      <span>
                        {getDateByMonth(startDate) +
                          " - " +
                          getDateByMonth(endDate) +
                          ""}
                      </span>
                    </div>
                  </div>

                  <div className={styles.mobile_new_right_div}>
                    <div className={styles.mobile_new_right_div_svg}>
                      <SvgMan />
                    </div>
                    <div className={styles.mobile_new_right_div_guest}>
                      {adult}
                    </div>
                  </div>
                </div>
                {modifyPkg && (
                  <div className={styles.lower_form}>
                    {/* <div>
               
                    <label htmlFor="">City/Destination</label>
                    <PackagesStateInputNewUi
                      onDataChange={getDataFromChild}
                      width={width}
                      disableSearchInput={true}
                    />
                  </div> */}
                    <div className="new_date_picker_react_js_custom_styling">
                      <label>Check In - Check Out</label>
                      <DatePicker
                        selected={startDate}
                        onChange={(dates) => {
                          const [start, end] = dates;
                          setStartDate(start);
                          setEndDate(end);
                        }}
                        startDate={startDate}
                        endDate={endDate}
                        selectsRange
                        portalId="root-portal NewUIReactDatePicker"
                        popperPlacement="bottom-start"
                        minDate={new Date()} // Prevent past dates selection
                        dateFormat="dd MMM, yyyy"
                        placeholderText={`${format(
                          startDate,
                          "dd MMM, yyyy"
                        )} - ${format(endDate, "dd MMM, yyyy")}`}
                      />
                      {/* <input
                        className="testform_input"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        type="date"
                        required
                      />
                    </div>
                    <div className="">
                      <label>Check Out</label>
                      <input
                        className="testform_input"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        type="date"
                        required
                      /> */}
                    </div>
                    <div className="search_form_div p_0 icon_button_only">
                      <label
                        onClick={dropdownGuestDetails}
                        className="search_label"
                      >
                        Room & Guests{" "}
                        <svg
                          width="9"
                          height="5"
                          viewBox="0 0 9 5"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.25 0.75L4.75 4.25L1.25 0.75"
                            stroke="#BB735D"
                          />
                        </svg>
                      </label>
                      <p
                        style={{ position: "relative" }}
                        className="SingleSearch-Guests dropdown-toggle search_form_input testform_input"
                      >
                        <div onClick={dropdownGuestDetails} ref={dropdownRef}>
                          <div className="optionCounter"></div>
                          <span id="adults_count">{adult}</span>
                          <span> Adults,</span>{" "}
                          <span id="room_count">{rooms}</span>
                          <span> Rooms, </span>{" "}
                          <span id="child_count">{children}</span>
                          <span> Children</span>
                        </div>
                        {guestDetails && (
                          <div ref={dropdownRef} className="popup-container">
                            <GuestDetailsPopup
                              guestDetails={guestDetails}
                              setIsguestDetails={setIsguestDetails}
                              adult={adult}
                              setAdults={setAdults}
                              children={children}
                              setChildren={setChildren}
                              rooms={storeRoomsData}
                              setRooms={setStoreRoomsData}
                              onRoomsChange={setStoreRoomsData}
                              handleRoomsUpdate={setStoreRoomsData}
                              setChildAge={setChildAge}
                              onAdultChange={setAdults}
                              childAge={childAge}
                              removeRoom={removeRoom}
                              onAdultIncrease={onAdultIncrease}
                              onAdultDecrease={onAdultDecrease}
                              toggleGuestDetailsPopup={toggleGuestDetailsPopup}
                              addRoom={addRoom}
                              addChildAge={addChildAge}
                              removeChild={removeChild}
                              availableAges={[2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}
                            />
                          </div>
                        )}
                      </p>
                    </div>
                    <button
                      // style={{ marginBottom: "10px" }}
                      type="submit"
                      className={styles.submitButton}
                    >
                      Modify
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <div className={styles.EditSearchFormParent}>
                <div className={styles.EditSearchFormChild}>
                  {/* <div className={styles.EditSearchFormChildFirstDiv}>
                    <PackagesStateInputNewUi
                      onDataChange={getDataFromChild}
                      // disableSearchInput={true}
                      width={width}
                    />
                  </div> */}
                  <div
                    className={`${styles.EditSearchFormChildSecondDiv} new_date_picker_react_js_custom_styling`}
                  >
                    {/* <Flatpickr
                      style={{ fontWeight: "lighter" }}
                      className="testform_input"
                      value={[startDate, endDate]}
                      onChange={([date1, date2]) => {
                        setStartDate(date1 || null);
                        setEndDate(date2 || null);
                      }}
                      options={{
                        mode: "range",
                        minDate: "today", // Prevent selection of past dates
                      }}
                      required
                    /> */}

                    <DatePicker
                      showIcon
                      selected={startDate}
                      onChange={(dates) => {
                        const [start, end] = dates;
                        setStartDate(start);
                        setEndDate(end);
                      }}
                      startDate={startDate}
                      endDate={endDate}
                      selectsRange
                      portalId="root-portal NewUIReactDatePicker"
                      popperPlacement="bottom-start"
                      minDate={new Date()} // Prevent past dates selection
                      dateFormat="dd MMM, yyyy"
                      placeholderText={`${format(
                        startDate,
                        "dd MMM, yyyy"
                      )} - ${format(endDate, "dd MMM, yyyy")}`}
                    />
                  </div>
                  <div className={styles.EditSearchFormChildThirdDiv}>
                    <p
                      style={{ position: "relative" }}
                      className="SingleSearch-Guests dropdown-toggle search_form_input testform_input"
                    >
                      <div onClick={dropdownGuestDetails} ref={dropdownRef}>
                        <div className="optionCounter"></div>
                        <span id="adults_count">{adult}</span>
                        <span> Adults,</span>{" "}
                        <span id="room_count">{rooms}</span>
                        <span> Rooms, </span>{" "}
                        <span id="child_count">{children}</span>
                        <span> Children</span>
                      </div>
                      {guestDetails && (
                        <div ref={dropdownRef} className="popup-container">
                          <GuestDetailsPopup
                            guestDetails={guestDetails}
                            setIsguestDetails={setIsguestDetails}
                            adult={adult}
                            setAdults={setAdults}
                            children={children}
                            setChildren={setChildren}
                            rooms={storeRoomsData}
                            setRooms={setStoreRoomsData}
                            onRoomsChange={setStoreRoomsData}
                            handleRoomsUpdate={setStoreRoomsData}
                            setChildAge={setChildAge}
                            onAdultChange={setAdults}
                            childAge={childAge}
                            removeRoom={removeRoom}
                            onAdultIncrease={onAdultIncrease}
                            onAdultDecrease={onAdultDecrease}
                            toggleGuestDetailsPopup={toggleGuestDetailsPopup}
                            addRoom={addRoom}
                            addChildAge={addChildAge}
                            removeChild={removeChild}
                            availableAges={[2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}
                          />
                        </div>
                      )}
                    </p>
                  </div>
                </div>
                <button type="submit" className={styles.submitButton}>
                  Modify
                </button>
              </div>
            )}
          </form>
        )}

        <input type="hidden" name="hotelId" value="{{ $hotelId }}" />
      </div>
    </section>
  );
}

export default SingleHotelSearchForm;
